import React, { memo } from 'react'

import {
  BrushAI, Button, CubeAIOutline, Download, Icon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

import { iconSize } from 'Pods/LazyLoaded/ImageGalleryPanel/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import { NOOP } from 'Utils/stableDefaults'

const editIcon = <Icon svgComponent={BrushAI} size={iconSize} color="darker" notSpaced />
const downloadIcon = <Icon svgComponent={Download} size={iconSize} color="darker" notSpaced />
const generateIcon = <Icon svgComponent={CubeAIOutline} size={iconSize} color="light" notSpaced />

// Hover actions of an image card.
function Actions({
  title,
  onEdit = NOOP,
  onDownload = NOOP,
  onGenerate3d = NOOP,
}) {
  const t = useTranslation()

  return (
    <>
      <div className="image-gallery-card__actions">
        <Button
          type="secondary"
          size="tiny"
          variant="only-icon"
          actionType="button"
          icon={editIcon}
          customClass="image-gallery-card__action"
          onClick={onEdit}
          aria-label={t('imageGallery.card.edit', { title })}
        />
        <Button
          type="secondary"
          size="tiny"
          variant="only-icon"
          actionType="button"
          icon={downloadIcon}
          customClass="image-gallery-card__action"
          onClick={onDownload}
          aria-label={t('imageGallery.card.download', { title })}
        />
      </div>
      <Button
        type="secondary"
        size="tiny"
        variant="with-icon"
        actionType="button"
        icon={generateIcon}
        customClass="image-gallery-card__generate"
        onClick={onGenerate3d}
        aria-label={t('imageGallery.card.generate3dFor', { title })}
      >
        {t('imageGallery.card.generate3d')}
      </Button>
    </>
  )
}

Actions.propTypes = {
  title: string.isRequired,
  onEdit: func,
  onDownload: func,
  onGenerate3d: func,
}

export default memo(Actions)
